const PAIR_SYMBOL_TO_PAIR_ADDRESS = {
  // This might have changed
  cUSD_DAI: "0x850197dd5a4865324291d7b5745622a8cd732bcb",
  WETH_CELO: "0x517f717f0ae11efc2af8943071b66d77dfafc9fc",
  cUSD_USDC: "0xa364ede5590b46e618527d7535506743d978bbf2"
};

const PAIR_ADDRESS_TO_REWARDS_POOL = {
  // This might have changed
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.cUSD_DAI]: 8,
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.WETH_CELO]: 1,
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.cUSD_USDC]: 5
};

const POOL_ID_TO_REWARDS_ADDRESSES = {
  [PAIR_ADDRESS_TO_REWARDS_POOL[PAIR_SYMBOL_TO_PAIR_ADDRESS.cUSD_DAI]]: ["0x29dfce9c22003a4999930382fd00f9fd6133acd1", "0x471ece3750da237f93b8e339c536989b8978a438"],
  [PAIR_ADDRESS_TO_REWARDS_POOL[PAIR_SYMBOL_TO_PAIR_ADDRESS.WETH_CELO]]: ["0x29dfce9c22003a4999930382fd00f9fd6133acd1", "0x471ece3750da237f93b8e339c536989b8978a438"],
  [PAIR_ADDRESS_TO_REWARDS_POOL[PAIR_SYMBOL_TO_PAIR_ADDRESS.cUSD_USDC]]: ["0x29dfce9c22003a4999930382fd00f9fd6133acd1", "0x471ece3750da237f93b8e339c536989b8978a438"],
};

const PAIR_ADDRESS_TO_REWARDS_LENGTH = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.WETH_CELO]: 2,
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.cUSD_DAI]: 2
};

module.exports = {
  ADDRESS: "0x8084936982D089130e001b470eDf58faCA445008",
  PAIR_SYMBOL_TO_PAIR_ADDRESS,
  POOL_ID_TO_REWARDS_ADDRESSES,
  PAIR_ADDRESS_TO_REWARDS_POOL,
  PAIR_ADDRESS_TO_REWARDS_LENGTH
};
